import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=f17a3ecc&"
import script from "./MessageView.vue?vue&type=script&lang=js&"
export * from "./MessageView.vue?vue&type=script&lang=js&"
import style0 from "./MessageView.vue?vue&type=style&index=0&id=f17a3ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports